module.exports = __webpack_public_path__ + "static/toplogo-bff2d85997121086170fe0891adf8fa4.png";